import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ApiInterceptorService implements HttpInterceptor{

  constructor(private authenticationService: AuthenticationService, private router: Router,
              private configService: ConfigService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
    if (this.configService.GetApiUrl() != undefined && !request.url.startsWith(this.configService.GetApiUrl()))
      return next.handle(request);
    const dupReq = request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + this.authenticationService.GetAccessToken()
      }
    })
    return next.handle(dupReq);
  }
}
